var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinefee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 0.501,
    strokeLinejoin: "bevel",
    strokeMiterlimit: 10,
    fontFamily: "Times New Roman",
    fontSize: 16,
    style: {
      fontVariantLigatures: "none"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    width: "47.5pt",
    height: "47.5pt",
    viewBox: "458.875 -559.125 47.5 47.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 1",
    transform: "scale(1 -1)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0141\\u0161\\u0164\\u015F 1",
    transform: "scale(1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 477.428,520.375 L 463.625,520.375 C 461.415,520.375 459.625,522.166 459.625,524.375 L 459.625,554.375 C 459.625,556.585 461.415,558.375 463.625,558.375 L 493.625,558.375 C 495.834,558.375 497.625,556.585 497.625,554.375 L 497.625,540.572",
    fill: "none",
    strokeWidth: 1.5,
    stroke: "#555555",
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 478.625,558.375 L 478.625,533.111",
    fill: "none",
    strokeWidth: 1.5,
    stroke: "#555555",
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 459.625,539.375 L 484.887,539.375",
    fill: "none",
    strokeWidth: 1.5,
    stroke: "#555555",
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 492.625,512.375 C 485.456,512.375 479.625,518.207 479.625,525.375 C 479.625,532.544 485.456,538.375 492.625,538.375 C 499.793,538.375 505.625,532.544 505.625,525.375 C 505.625,518.207 499.793,512.375 492.625,512.375 Z",
    strokeWidth: 1.5,
    stroke: "#555555",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    markerStart: "none",
    markerEnd: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 488.625,522.375 C 488.625,520.719 489.968,519.375 491.625,519.375 L 493.625,519.375 C 495.281,519.375 496.625,520.719 496.625,522.375 L 496.625,522.375 C 496.625,524.032 495.281,525.375 493.625,525.375 L 491.625,525.375 C 489.968,525.375 488.625,526.719 488.625,528.375 L 488.625,528.375 C 488.625,530.032 489.968,531.375 491.625,531.375 L 493.625,531.375 C 495.281,531.375 496.625,530.032 496.625,528.375 L 496.625,528.375",
    fill: "none",
    strokeWidth: 1.5,
    stroke: "#555555",
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 492.625,519.375 L 492.625,516.375",
    fill: "none",
    strokeWidth: 1.5,
    stroke: "#555555",
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 492.625,534.375 L 492.625,531.375",
    fill: "none",
    strokeWidth: 1.5,
    stroke: "#555555",
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 483.625,548.375 L 491.625,548.375",
    fill: "none",
    strokeWidth: 1.5,
    stroke: "#555555",
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 465.625,532.375 L 473.625,532.375",
    fill: "none",
    strokeWidth: 1.5,
    stroke: "#555555",
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 465.625,528.375 L 473.625,528.375",
    fill: "none",
    strokeWidth: 1.5,
    stroke: "#555555",
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 487.625,544.375 L 487.625,552.375",
    fill: "none",
    strokeWidth: 1.5,
    stroke: "#555555",
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 465.796,545.547 L 471.453,551.204",
    fill: "none",
    strokeWidth: 1.5,
    stroke: "#555555",
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 471.453,545.547 L 465.796,551.204",
    fill: "none",
    strokeWidth: 1.5,
    stroke: "#555555",
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinefee);
export default __webpack_public_path__ + "static/media/finefee.9ca72f2128ef1b6d0ed4a58a765ca999.svg";
export { ForwardRef as ReactComponent };